import React from "react";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { ThemeProvider } from "@emotion/react";
import theme from "../../../themes/theme";
import { Button } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import "./AdminCard.css";
import BASE_URL from "../../../config/api";
import { useNavigate, useLocation } from "react-router";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";

export default function AdminCard({ course, id, disabled }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isStatisticsPage = location.pathname === "/course/statistics";

  const handleClick = () => {
    navigate(`/courses/${course._id}`);
  };

  const handleEdit = () => {
    navigate(`/courses/${course._id}/sections`);
  };

  const handleAdd = () => {
    navigate(`/courses/${course._id}/add-user`);
  };
  const handleStatistics = () => {
    navigate(`/course-students/${course._id}`);
  };

  return (
    <div className="card">
      <div className="left-part">
        <p className="course-title">{course.title}</p>
        <div className="icons-container">
          <GroupsIcon fontSize="small" />
          <p style={{ padding: "5px" }}>{course.instructor}</p>
        </div>
        {!isStatisticsPage && (
          <p className="course-desc">{course.description}</p>
        )}
        <ThemeProvider theme={theme}>
          <div className="btn-wrapper">
            {isStatisticsPage ? (
              <Button
                disabled={disabled}
                variant="contained"
                id="statistics"
                onClick={handleStatistics}
                sx={{
                  "&:disabled": {
                    backgroundColor: "#0E1937",
                    color: "white",
                  },
                }}
              >
                <SignalCellularAltIcon />
                &nbsp; <span className="start">View Statistics</span>
              </Button>
            ) : (
              <>
                <Button
                  disabled={disabled}
                  variant="contained"
                  id="start"
                  onClick={handleClick}
                  sx={{
                    "&:disabled": {
                      backgroundColor: "#0E1937",
                      color: "white",
                    },
                  }}
                >
                  <CastForEducationIcon />
                  &nbsp; <span className="start">Edit / Manage course </span>
                </Button>
                <Button
                  disabled={disabled}
                  variant="outlined"
                  id="second"
                  onClick={handleEdit}
                  sx={{
                    "&:disabled": {
                      backgroundColor: "#0E1937",
                      color: "white",
                    },
                  }}
                >
                  <DriveFileRenameOutlineIcon /> &nbsp;{" "}
                  <span className="start">Edit / Add section</span>
                </Button>
                <Button
                  disabled={disabled}
                  variant="outlined"
                  id="third"
                  onClick={handleAdd}
                  sx={{
                    "&:disabled": {
                      backgroundColor: "#0E1937",
                      color: "white",
                    },
                  }}
                >
                  <AccountCircleIcon /> &nbsp;{" "}
                  <span className="start">Add users</span>
                </Button>
              </>
            )}
          </div>
        </ThemeProvider>
      </div>
      <div className="right-part">
        <img
          alt="course-img"
          className="course-img"
          src={`${BASE_URL}/courses/${id}/image`}
        />
      </div>
    </div>
  );
}
